import { render, staticRenderFns } from "./SubjectDetailed.vue?vue&type=template&id=30a632fe"
import script from "./SubjectDetailed.vue?vue&type=script&lang=js"
export * from "./SubjectDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports